import { render, staticRenderFns } from "./_tag.vue?vue&type=template&id=d9c272cc&scoped=true&"
import script from "./_tag.vue?vue&type=script&lang=js&"
export * from "./_tag.vue?vue&type=script&lang=js&"
import style0 from "./_tag.vue?vue&type=style&index=0&id=d9c272cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c272cc",
  null
  
)

export default component.exports